export const TRIGGER_COUNT_FETCH = '@@doctorTab/TRIGGER_COUNT_FETCH';

export const triggerCountFetch = () => ({
    type: TRIGGER_COUNT_FETCH,
});
